<template>
  <div class="tbe-pre-order-details">
    <tbe-alert group="preOrderDetails">
      <template #payload="{ product, option, date, order, amountPeople }">
        <ul>
          <li>
            <span>Product: </span><b>{{ product.title }}</b>
          </li>
          <template v-if="option">
            <li>
              <span>Option: </span><b>{{ option.title }}</b>
            </li>
            <li>
              <span>Duration: </span><b>{{ option.duration || product.duration }} min</b>
            </li>
          </template>
          <li v-if="order.startTime">
            <span>Date: </span>
            <b>{{ $filters.dateFormat(date, 'E, MMM dd, yyyy') }}, {{ order.startTime.time }}</b>
          </li>
          <li>
            <span>Language: </span><b>{{ order.language }}</b>
          </li>
          <li>
            <span>Number of people: </span><b>{{ amountPeople }}</b>
          </li>
        </ul>
      </template>
    </tbe-alert>
  </div>
</template>

<script>
  import { computed, onMounted } from 'vue'
  import { useStore } from 'vuex'
  import { useI18n } from 'vue-i18n'

  import tbeAlert, { useAlert } from 'common/plugins/rs-alert'

  export default {
    name: 'tbePreOrderDetails',

    components: { tbeAlert },

    setup() {
      const { t } = useI18n()

      const store = useStore()
      const alert = useAlert()

      const amountPeople = computed(() => store.state.booking.order.amountPeople)
      const date = computed(() => store.state.booking.order.date)

      const order = computed(() => store.state.booking.order)
      const product = computed(() => store.state.booking.product)
      const option = computed(() => {
        return store.state.booking.options.find((option) => option.id === order.value.optionId)
      })

      onMounted(() => {
        alert.add({
          severity: 'success',
          payload: {
            product,
            option,
            date,
            order,
            amountPeople
          },
          group: 'preOrderDetails',
          closable: false
        })
      })

      return { t, amountPeople, date, order, product, option }
    }
  }
</script>

<style lang="scss" scoped>
  .tbe-pre-order-details {
    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
      li {
        margin-bottom: 10px;
        &:last-of-type {
          margin-bottom: 0;
        }
      }
    }
  }
</style>
